/* UD Brand interactions — scroll reveal, mobile nav, ticker duplication */
(function () {
  'use strict';

  /* ----- Scroll-reveal ----- */
  function initReveal() {
    var els = document.querySelectorAll('.ud-reveal');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ----- Ticker: duplicate track items so the marquee loops seamlessly ----- */
  function initTicker() {
    document.querySelectorAll('.ud-ticker__track').forEach(function (track) {
      if (track.dataset.tickerInit) return;
      track.dataset.tickerInit = '1';
      var clone = track.innerHTML;
      track.innerHTML = clone + clone;
    });
  }

  /* ----- Mobile nav drawer ----- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-ud-nav-toggle]');
    var drawer = document.querySelector('[data-ud-nav-drawer]');
    if (!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('[data-ud-nav-close]');
    function open() {
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.removeAttribute('data-open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });
  }

  /* ----- Live cart count bridge ----- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-ud-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  }

  function refreshCartCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') updateCartCount(c.item_count); })
      .catch(function () { /* ignore */ });
  }

  function init() {
    initReveal();
    initTicker();
    initMobileNav();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Listen for Shopify section reloads in the theme editor */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', refreshCartCount);
})();
